export * from './Text.component'
export * from './Text.types'
